exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LeftSidebar-ce9fda77{height:100%;display:flex;flex-direction:column}.LeftSidebar-ce9fda77 .routeInfo-c3ef008d{padding:1em;flex:0 0 auto}.LeftSidebar-ce9fda77 .routeInfo-c3ef008d .metrics-d62cf494{font-size:13px}\n", ""]);

// Exports
exports.locals = {
	"LeftSidebar": "LeftSidebar-ce9fda77",
	"routeInfo": "routeInfo-c3ef008d",
	"metrics": "metrics-d62cf494"
};